import { z } from "zod";

import { createPaginatedResponseSchema } from "../api/pagination";
import { type ImageMedia, ImageMediaSchema } from "../media/image";

export enum UserImageType {
  PUBLIC_IMAGE = "PUBLIC",
  PRIVATE_IMAGE = "PRIVATE",
  BACKGROUND_IMAGE = "BACKGROUND",
  AVATAR = "AVATAR",
}

export type UserImageMedia = {
  id: string;
  username: string;
  type: UserImageType;
  likeCount: number;
  attributes: ImageMedia;
};

export const UserImageMediaSchema = z.object({
  id: z.string(),
  username: z.string(),
  type: z.enum([
    UserImageType.AVATAR,
    UserImageType.BACKGROUND_IMAGE,
    UserImageType.PUBLIC_IMAGE,
    UserImageType.PRIVATE_IMAGE,
  ]),
  likeCount: z.number(),
  attributes: ImageMediaSchema,
});

export type UserLikableImageMedia = {
  isLiked: boolean;
  image: UserImageMedia;
};

export const UserLikableImageMediaSchema = z.object({
  isLiked: z.boolean(),
  image: UserImageMediaSchema,
});

export type ImageMetaData = {
  imageHash: string;
  imageS3Key: string;
  imageType: UserImageType;
};

export const ImageMetaDataSchema = z.object({
  imageHash: z.string(),
  imageS3Key: z.string(),
  imageType: z.enum([
    UserImageType.AVATAR,
    UserImageType.BACKGROUND_IMAGE,
    UserImageType.PUBLIC_IMAGE,
    UserImageType.PRIVATE_IMAGE,
  ]),
});

export type ImageMediaResponse = {
  images: UserImageMedia[];
};

export const ImageMediaResponseSchema = z.object({
  images: z.array(UserImageMediaSchema),
});

export type UserLikableImageMediaResponse = {
  images: UserLikableImageMedia[];
};

export const UserLikableImageMediaResponseSchema = z.object({
  images: z.array(UserLikableImageMediaSchema),
});

export const PaginatedMediaSchema =
  createPaginatedResponseSchema(UserImageMediaSchema);
